export const getChoices = (items) => {
	return Object.values(items).map((item) =>
		item.name.slice(0, 2).toLowerCase()
	);
};
